// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t353 (21-oct-2026) · LucIA ESCONDIDA UN RATO (la X roja de su botón)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «con una X roja que destaque arriba a la izquierda para cerrarlo momentáneamente y que no moleste, porque se
//  ponga donde se ponga, va a molestar». Al pulsar la X (utils/luciaEnLaEsquina · BotonLuciaFlotante), LucIA se esconde
//  hasta que se vuelve a cargar la página o pasan dos horas, lo primero que llegue. Vuelve antes con la pestañita del
//  borde derecho (PestanaLucia) o con «Mostrar a LucIA» en el «?» de arriba (utils/contactoBiango).
//
//  CÓMO: la hora hasta la que está escondida se guarda en sessionStorage (así aguanta un cambio de pantalla que cargue
//  la página de nuevo, como salir y volver a entrar), y al arrancar se olvida si la carga es una RECARGA (F5 o el botón
//  del navegador): «hasta que se recargue la página». Todo dentro de try/catch: sin almacén (ventana privada, bloqueado)
//  se queda en la memoria de esta página y funciona igual.
//
//  Sin imports a propósito: lo cargan de verdad las guardias (test-helpers/utilDelFrontend), lo comparten el botón, el
//  globo (components/ChatWidget) y el «?». Lo mide backend/routes/lucia-abajo-a-la-derecha.test.js.

export const CLAVE_LUCIA_ESCONDIDA = 'biango:lucia-escondida-hasta'
export const RATO_LUCIA_ESCONDIDA_MS = 2 * 60 * 60 * 1000

let hasta = 0
let arrancada = false
let temporizador = null
const oyentes = new Set()

const ventanaDe = (w) => (w !== undefined ? w : (typeof window !== 'undefined' ? window : null))
function almacenDe(w) {
  try { return (w && w.sessionStorage) || null } catch (_) { return null }
}
function esRecarga(w) {
  try {
    const p = w && w.performance
    if (!p) return false
    const n = typeof p.getEntriesByType === 'function' ? p.getEntriesByType('navigation') : null
    if (n && n[0] && n[0].type) return n[0].type === 'reload'
    return !!(p.navigation && p.navigation.type === 1)
  } catch (_) { return false }
}
function avisar() {
  for (const f of Array.from(oyentes)) { try { f(hasta) } catch (_) { /* un oyente roto no para a los demás */ } }
}
function programar(w, ahora) {
  if (temporizador) { clearTimeout(temporizador); temporizador = null }
  if (!(hasta > ahora)) return
  const espera = Math.min(hasta - ahora + 50, RATO_LUCIA_ESCONDIDA_MS + 1000)
  try {
    temporizador = setTimeout(() => { temporizador = null; if (!(hasta > Date.now())) { hasta = 0; borrar(w); avisar() } }, espera)
  } catch (_) { temporizador = null }
}
function borrar(w) {
  const a = almacenDe(w)
  try { if (a) a.removeItem(CLAVE_LUCIA_ESCONDIDA) } catch (_) { /* sin almacén */ }
}

// Una vez por carga de la página (lo llama el primero que pregunta): lee la hora guardada, salvo en una recarga.
export function arrancarLuciaEscondida({ w, ahora = Date.now() } = {}) {
  const v = ventanaDe(w)
  arrancada = true
  hasta = 0
  const a = almacenDe(v)
  if (esRecarga(v)) { borrar(v); return hasta }
  try {
    const guardado = a ? Number(a.getItem(CLAVE_LUCIA_ESCONDIDA)) : 0
    if (guardado > ahora && guardado <= ahora + RATO_LUCIA_ESCONDIDA_MS) hasta = guardado
    else if (guardado) borrar(v)
  } catch (_) { hasta = 0 }
  programar(v, ahora)
  return hasta
}

export function luciaEscondida(ahora = Date.now()) {
  if (!arrancada) arrancarLuciaEscondida({ ahora })
  return hasta > ahora
}

export function esconderLucia({ w, ahora = Date.now() } = {}) {
  const v = ventanaDe(w)
  arrancada = true
  hasta = ahora + RATO_LUCIA_ESCONDIDA_MS
  const a = almacenDe(v)
  try { if (a) a.setItem(CLAVE_LUCIA_ESCONDIDA, String(hasta)) } catch (_) { /* sin almacén: se queda en esta página */ }
  programar(v, ahora)
  avisar()
  return hasta
}

export function mostrarLucia({ w } = {}) {
  const v = ventanaDe(w)
  arrancada = true
  hasta = 0
  if (temporizador) { clearTimeout(temporizador); temporizador = null }
  borrar(v)
  avisar()
}

// Devuelve con qué darse de baja (para el `return` de un useEffect).
export function suscribirLuciaEscondida(f) {
  oyentes.add(f)
  return () => { oyentes.delete(f) }
}
